// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ZjCS","rootNoMargin":"styles_rootNoMargin__2Xf5K"};